<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-warn-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <h6 class="title"></h6>
                <div class="dialog-body">
                    <div class="result-list">
                        <ul>
                            <li v-for="(r,k) in result_config" :key="k">
                                {{ r }}
                            </li>
                        </ul>
                    </div>
                </div>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            result_config : [],
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
    },
}
</script>

<style scoped>
/* share */
.m-warn-modal {
    width: 620px;
    height: 336px;
    background-image: url(~@/assets/images/utils/bg-modal-warn.png);
}

.dialog-wrapper{
    padding: 0 10px 0;
}

.m-warn-modal h6 {
    width: 427px;
    height: 27px;
    margin: 0 auto 40px;
    background-image: url(~@/assets/images/utils/title-result.png);
}

.m-warn-modal .dialog-text {
    /* font-size: 20px; */
    color: #c03b20;
    text-align: center;
    word-break: break-all;
}

.dialog-text p{
    margin-bottom: 4px;
}

.result-list{
    margin-top: 10px;
}

.result-list ul{
    display: flex;
    /* justify-content: space-between; */
    flex-wrap: wrap;
    padding: 0 30px;
}

.result-list li{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 24px;
    color: #a1837d;
    text-align: center;
    word-break: break-all;
    margin: 0 7px 10px;
}

.m-warn-modal .u-btn.copy {
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 240px;
    height: 80px;
    margin-left: -120px;
    background-image: url(~@/assets/images/utils/btn-copy.png);
}
</style>


// WEBPACK FOOTER //
// src/components/ResultModal/resultModal.vue